import { PostPage } from "@/components/formats/post-page";
import { MemeGrid, MobileBackBtn, TitleShadow } from "@/components/styles";
import MemeTemplate from "@/components/ui/meme-template";
import UploadMemeTemplate from "@/components/ui/upload-meme-template";
import useUserStore from "@/state/user/useUserStore";
import { Asset } from "@/types/types";
import React, { useEffect } from "react";
import {
  ArrowBigLeft,
  Disc3,
  Eye,
  GraduationCap,
  PawPrint,
  Shirt,
  Smile,
  Star,
} from "lucide-react";
import { BannerPage } from "@/components/formats/banner-page";
import { PostPageMobile } from "@/components/formats/post-page-mobile";
import Image from "@/components/ui/image";
import Link from "next/link";

const BlankMobilePage = ({ disabled }: { disabled?: boolean }) => {
  const [
    selectedImage,
    uploadedImage,
    tabs,
    assetsCount,
    imageFormat,
    setRestrictedFonts,
  ] = useUserStore((state) => [
    state.selectedImage,
    state.uploadedImage,
    state.tabs,
    state.assetsCount,
    state.imageFormat,
    state.setRestrictedFonts,
  ]);

  useEffect(() => {
    setRestrictedFonts([
      { value: "title13", label: "Henlo Clash" },
      { value: "title14", label: "Inter" },
      { value: "title15", label: "Inter Bold" },
    ]);
  }, []);

  const HeadAssets = Array.from(
    { length: 35 },
    (_, i) => `/Mememaker/henlo3/heads/head${i + 1}.png`
  );

  const BodyAssets = Array.from(
    { length: 3 },
    (_, i) => `/Mememaker/henlo3/bodies/body${i + 1}.png`
  );

  const BeraAssets = Array.from(
    { length: 67 },
    (_, i) => `/Mememaker/henlo3/beras/bera${i + 1}.png`
  );

  const HenloAssets = Array.from(
    { length: 38 },
    (_, i) => `/Mememaker/henlo3/henlo/henlo${i + 1}.png`
  );

  const allAssets: Asset[] = [
    {
      assets: HeadAssets,
      icon: <Smile />,
    },
    { assets: BodyAssets, icon: <Shirt /> },
    { assets: BeraAssets, icon: <PawPrint /> },
    { assets: HenloAssets, icon: <Star /> },
    { assets: [], icon: <Eye /> },
  ];

  return (
    <div
      style={{
        height: "100vh",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        gap: "12px",
      }}
    >
      {disabled ? (
        <>
          <div
            style={{
              width: "4rem",
              height: "4rem",
              position: "relative",
            }}
          >
            <Image
              src={"/Mememaker/beraflip/beraflip.png"}
              alt={"beraflip"}
              fill
              style={{
                objectFit: "contain",
              }}
            />
          </div>
          <p
            style={{
              margin: 0,
              fontFamily: "var(--font-cabin-condensed)",
              fontSize: "20px",
              height: "3rem",
              display: "flex",
              alignItems: "center",
              justifyContent: "start",
              color: "#000",
              textAlign: "center",
            }}
          >
            Please access on desktop for the best experience.
          </p>
        </>
      ) : (
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "space-between",
            position: "relative",
          }}
        >
          {(() => {
            switch (imageFormat) {
              case "banner":
                return (
                  <BannerPage
                    color={"#2e64fb"}
                    assets={allAssets}
                    websiteLink="https://www.0xhoneyjar.xyz/"
                  />
                );
              case "post":
                return (
                  <PostPageMobile
                    color={"#2e64fb"}
                    assets={allAssets}
                    websiteLink="https://www.0xhoneyjar.xyz/"
                  />
                );
              default:
                return (
                  <div
                    style={{
                      width: "100%",
                      height: "auto",
                      display: "flex",
                      flexDirection: "column",
                      boxSizing: "border-box",
                      padding: "16px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        marginBottom: "16px",
                      }}
                    >
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          alignItems: "start",
                          justifyContent: "center",
                          flexDirection: "column",
                        }}
                      >
                        <TitleShadow style={{ margin: 0, marginBottom: "4px" }}>
                          Create
                        </TitleShadow>
                        <p
                          style={{
                            margin: 0,
                            fontFamily: "var(--font-cabin-condensed)",
                          }}
                        >
                          Select a preset meme template or upload your own.
                        </p>
                      </div>
                      <Link
                        style={{
                          margin: 0,
                          fontSize: "16px",
                          fontFamily: "var(--font-cabin-condensed)",
                          whiteSpace: "nowrap",
                          textDecoration: "none",
                          color: "black",
                        }}
                        href="/"
                      >
                        <MobileBackBtn
                          whileHover={{
                            scale: 1.02,
                            transition: {
                              duration: 0.15,
                              ease: "linear",
                            },
                          }}
                          whileTap={{ scale: 0.99 }}
                        >
                          <ArrowBigLeft size={20} />
                        </MobileBackBtn>
                      </Link>
                    </div>
                    <div
                      style={{
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        flexDirection: "row",
                        gap: "16px",
                      }}
                    >
                      <MemeGrid>
                        <MemeTemplate src="/Mememaker/henlo3/background/bg1.png" />
                        <MemeTemplate src="/Mememaker/henlo3/background/bg2.png" />
                        <MemeTemplate src="/Mememaker/henlo3/background/bg3.png" />
                        <MemeTemplate src="/Mememaker/henlo3/background/bg4.png" />
                        <MemeTemplate src="/Mememaker/henlo3/background/bg5.png" />
                        <UploadMemeTemplate />
                      </MemeGrid>
                    </div>
                  </div>
                );
            }
          })()}
        </div>
      )}
    </div>
  );
};

export default BlankMobilePage;
